import React from "react";
import { Route, Routes as RouterRoutes } from "react-router-dom";
import App from "./App.jsx";
import { PagePlaceholder, ProtectedRoute } from "./components"; // Import the ProtectedRoute component
import {
  Amazon,
  BankDetails,
  Billing,
  BookedOrder,
  Channel,
  CheckServiceability,
  CODRemittance,
  CourierMgmt,
  CreditNote,
  DashBoard,
  EmployeeLogin,
  FetchOrderDetails,
  GstDetails,
  Invoice,
  LabelSetting,
  LoginPage,
  MyProfile,
  Ndr,
  NewBooking,
  PageNotFound,
  PersonalDetails,
  PickupAddress,
  Pricing,
  RateCalculator,
  Remarks,
  Reports,
  ResetPassword,
  SellerAgreement,
  Settings,
  ShippingCharges,
  ShippingId,
  SignUpPage,
  Support,
  Tracking,
  UnauthorizedUser,
  VerifiedEmail,
  Wallet,
  WalletTransaction,
  WeightDispute,
} from "./pages";
import { StepperContainer } from "./pages";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ShopifyOAuthHandler from "./components/ShopifyOAuthHandler.jsx";

const Routes = () => {
  return (
    <GoogleOAuthProvider
      clientId={import.meta.env.VITE_REACT_APP_GOOGLE_CLIENT_ID}
      onScriptLoadError={(err) => console.error("Script load error:", err)}
    >
      <ShopifyOAuthHandler>
        <RouterRoutes>
          {/* Public Routes */}
          <Route path="login" element={<LoginPage />} />
          <Route path="signup" element={<SignUpPage />} />

          <Route path="unauthorizedUser" element={<UnauthorizedUser />} />
          <Route path="verifiedEmail" element={<VerifiedEmail />} />
          <Route path="resetPassword" element={<ResetPassword />} />

          <Route path="amazon" element={<Amazon />} />
          <Route path="amazon/return" element={<Amazon />} />

          {/* Main Protected Layout */}
          <Route element={<ProtectedRoute requiredPermission="Dashboard" />}>
            <Route path="/" element={<App />}>
              <Route index element={<DashBoard />} />
              {/* Individual Permission-protected Routes */}
              <Route path="my-profile" element={<MyProfile />} />
              <Route
                element={<ProtectedRoute requiredPermission="New Booking" />}
              >
                <Route path="newBooking" element={<NewBooking />} />
              </Route>
              <Route
                element={<ProtectedRoute requiredPermission="Booked Orders" />}
              >
                <Route path="bookedOrders" element={<BookedOrder />} />
              </Route>

              <Route element={<ProtectedRoute requiredPermission="Tracking" />}>
                <Route path="tracking" element={<Tracking />} />
                <Route
                  path="tracking/orderDetails"
                  element={<FetchOrderDetails />}
                />
              </Route>
              <Route element={<ProtectedRoute requiredPermission="wallet" />}>
                <Route path="wallet" element={<Wallet />} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission="NDR" />}>
                <Route path="ndr" element={<Ndr />} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission="Billing" />}>
                <Route path="billing" element={<Billing />}>
                  <Route path="pricing" element={<Pricing />} />
                  <Route path="codRemittance" element={<CODRemittance />} />
                  <Route
                    path="walletTransaction"
                    element={<WalletTransaction />}
                  />
                  <Route path="shippingCharges" element={<ShippingCharges />} />
                  <Route path="invoice" element={<Invoice />} />
                  <Route path="creditNote" element={<CreditNote />} />
                  <Route path="weightDispute" element={<WeightDispute />} />
                </Route>
              </Route>
              <Route element={<ProtectedRoute requiredPermission="Reports" />}>
                <Route path="reports" element={<Reports />} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission="settings" />}>
                <Route path="settings" element={<Settings />}>
                  <Route path="kyc" element={<StepperContainer />}>
                    <Route path="personal" element={<PersonalDetails />} />
                    <Route path="gst" element={<GstDetails />} />
                    <Route path="bank" element={<BankDetails />} />
                    <Route
                      path="sellerAgreement"
                      element={<SellerAgreement />}
                    />
                  </Route>
                  <Route path="channel" element={<Channel />} />
                  <Route path="labelSettings" element={<LabelSetting />} />
                  <Route path="employeeLogin" element={<EmployeeLogin />} />
                  <Route path="courierMgmt" element={<CourierMgmt />} />
                  <Route path="pickupAddress" element={<PickupAddress />} />
                  <Route path="shippingId" element={<ShippingId />} />
                </Route>
              </Route>
              <Route element={<ProtectedRoute requiredPermission="Support" />}>
                <Route path="support" element={<Support />} />
                <Route path="support/details/:id" element={<Remarks />} />
              </Route>
              <Route
                path="checkServiceability"
                element={<CheckServiceability />}
              />
              <Route path="rateCalculator" element={<RateCalculator />} />
            </Route>
          </Route>
          {/* Catch-all Route */}
          <Route path="*" element={<PageNotFound />} />
        </RouterRoutes>
      </ShopifyOAuthHandler>
    </GoogleOAuthProvider>
  );
};

export default Routes;
